/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { selectUserData } from '../../../Redux/UserSlice';
import moment from 'moment';
import { api_url } from '../../../Constants/web_services';
import { useNavigate } from 'react-router-dom';
import '../../../Assets/css/swal.css';
function AddTime({ order }) {
    const userData = useSelector(selectUserData);
    const [addDays, setAddDays] = useState('');
    const [newDate, setNewDate] = useState('');

    const [newDuration, setnewDuration] = useState();
    const [previousDate, setPreviousDate] = useState()
    const navigate = useNavigate();

    const addDate = (days) => {
        const currentDate = moment();
        const selectedDate = currentDate.add(parseInt(days), 'days');

        return selectedDate;
    };

    useEffect(() => {
        if (addDays && addDays !== '0') {
            const newD = addDate(addDays);
            setNewDate(moment(newD).format('DD-MM-YYYY'));
        } else {
            setNewDate('');
        }
    }, [addDays]);

    // const handleAddTime = async (e) => {

    //     e.preventDefault();
    //     try {
    //         const result = await Swal.fire({
    //             title: `Add Time`,
    //             text: `Add more to order id: ${order?.order_no}`,
    //             icon: "warning",
    //             showCancelButton: true,
    //             confirmButtonColor: "#3085d6",
    //             cancelButtonColor: "#d33",
    //             confirmButtonText: "Yes",
    //             cancelButtonText: "No",
    //         });

    //         if (result.isConfirmed) {
    //             const newD = addDate(addDays);
    //             setNewDate(moment(newD).format('DD-MM-YYYY'));

    //             // Format newDate according to the expected format by the backend
    //             const formattedDate = moment(newD).format('YYYY-MM-DD HH:mm:ss');

    //             // Perform POST request to API endpoint
    //             const response = await fetch(api_url + `/api/change-order-date/${userData?.id}/${order?.id}`, {
    //                 method: 'POST',
    //                 // headers: {
    //                 //     'Content-Type': 'application/json',
    //                 // },
    //                 mode: 'no-cors',
    //                 body: JSON.stringify({
    //                     // user_id: userData.id,
    //                     // id: order?.id,
    //                     end_duration: formattedDate,
    //                 }),
    //             });
    //             if (response.ok) {
    //                 console.log(response, 'shakjahlshodhauis')
    //                 setAddDays('');

    //                 // navigate(`/user-profile/${userData.id}/order-details/${order.id}`);
    //                 Swal.fire({
    //                     icon: 'success',
    //                     title: 'End duration is updated',
    //                     text: 'order Last Date is Updated',
    //                 });
    //             } else {
    //                 // Handle error response
    //                 Swal.fire({
    //                     icon: 'error',
    //                     title: 'Oops...',
    //                     text: 'Something went wrong!',
    //                 });
    //                 console.error('Failed to update Date');
    //                 throw new Error('Failed to update Date');
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         // Handle error, show error message, etc.
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Oops...',
    //             text: 'Something went wrong!',
    //         });
    //     }
    // };



    const handleAddTime = async (e) => {
        e.preventDefault();
        try {
            const result = await Swal.fire({
                title: `Add Time`,
                text: `Add more to order id: ${order?.order_no}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            });

            if (result.isConfirmed) {
                const newD = addDate(addDays);
                setNewDate(moment(newD).format('DD-MM-YYYY'));

                const formattedDate = moment(newD).format('YYYY-MM-DD HH:mm:ss');
                const token = localStorage.getItem('token');

                const response = await fetch(api_url + `/api/change-order-date/${order?.id}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        end_duration: formattedDate,
                    }),
                });


                if (response.ok) {
                    setAddDays('');
                    navigate(`/user-profile/${userData?.id}/order-details/${order?.id}`)
                    // window.location.reload()
                    Swal.fire({
                        icon: 'success',
                        title: 'End duration is updated',
                        text: `${order?.order_no} date is updated`,
                        customClass: {
                            popup: 'custom-swal-popup'
                        },
                        position: 'top-right',
                    });
                } else {
                    throw new Error('Failed to update Date');
                }
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            });
        }
    };


    useEffect(() => {

        setnewDuration(moment(order?.end_duration).format('DD-MM-YYYY'))
        setPreviousDate(moment().subtract(1, 'days').format('DD-MM-YYYY'))

    }, [order?.end_duration]);

    const handleInputChange = (e) => {
        setAddDays(e.target.value);
    };


    return (
        <>
            {previousDate <= moment().format('DD-MM-YYYY') ? (
                <>
                    <dt className="m-0"><u>Add time order</u></dt>
                    <details className="mb-3">
                        <summary className="text-danger fw-600">Here :</summary>
                        <form onSubmit={handleAddTime}>
                            <div className='row justify-content-between'>
                                <p className='pr-0'>Add Days to Your Order.</p>
                                <div className="col-md-6">
                                    <input
                                        style={{ maxHeight: '30px' }}
                                        type="number"
                                        className='form-control addDays'
                                        name="addDays"
                                        id="addDays"
                                        value={addDays}
                                        placeholder='add number of days'
                                        min="0"
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="col-md-6">
                                    {(addDays !== '' && addDays !== '0') && (
                                        <button
                                            type="submit"
                                            className="admin-button btn-sm addInvoice ml-3"
                                            style={{ width: "50px", height: "29px" }}
                                            title="Add Time"
                                        >
                                            <i className="fa fa-plus " style={{ fontSize: "8px" }} />
                                            <i className="fa fa-clock-o " style={{ fontSize: "16px" }} />
                                        </button>
                                    )}
                                </div>
                                {(addDays !== '' && addDays !== '0' && newDate) && (
                                    <p className='mt-2 text-022278 text-capitalize fw-600'>Your new selected date is :<span className='text-danger'> {newDate}</span></p>
                                )}
                            </div>
                        </form>
                    </details>
                </>
            )
                : (
                    <>
                        {/* <dt className="m-0"><u>Company have much time</u></dt>
    
                        <p className='text-022278 text-capitalize ml-4'>it show on last day</p> */}
                    </>)}

        </>

    )
}

export default AddTime;
